/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useState } from "react";
import { ContentZoneContext } from "cms/components/context";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { transformRichTextBulletList } from "./utils";
import { ReactComponent as CheckmarkIcon } from "assets/images/icons/checkmark.svg";

const FeatureAccordionComponentDisplay = () => {
    const context = useContext(ContentZoneContext);
    const component = context.component;
    const title = component.title;
    const subtitle = component.subtitle;
    const description = component.description;
    const sections = component.sections || [];

    
    const sectionItems = sections.map((section) => {
        return {
            title: section.title,
            description: section.description,
            items: transformRichTextBulletList(section),
            image: section.image
        };
    });
    const [image, setImage] = useState(sections[0]?.image?.url || null);
    const [expandedSection, setExpandedSection] = useState(0); // First section expanded by default

    const onChangeImage = (section) => {
        const imageUrl = section?.image?.url;
        setImage(imageUrl);
    };

    const handleSectionClick = (index, section) => {
        setExpandedSection(expandedSection === index ? -1 : index); // Toggle or set new expanded section
        onChangeImage(section);
    };

    return (
        <div className="feature-accordion-display">
            <div className="feature-accordion-display-title">
                <h2>{title}</h2>
            </div>
            <div className="feature-accordion-display-subtitle">
                <h4>{subtitle}</h4>
            </div>
            <div className="feature-accordion-display-description">
                <RichTextPreview richtext={description} />
            </div>
            <div className="feature-accordion-display-container">
                <div className="feature-accordion-display-container-left">
                    <img className="feature-accordion-display-container-left-image" src={image} alt={title} />
                </div>
                <div className="feature-accordion-display-container-right">
                    {sectionItems.map((section, index) => (
                        <div key={section?.title} className={`feature-accordion-display-section ${expandedSection === index ? "expanded" : "collapsed"}`}>
                            <button 
                                className="feature-accordion-display-section-title" 
                                onClick={() => handleSectionClick(index, section)}
                                aria-expanded={expandedSection === index}
                                type="button"
                            >
                                {section?.items?.title}
                            </button>
                            <div className="feature-accordion-display-section-content">
                                <p className="feature-accordion-display-section-description">{section?.items?.description}</p>
                                <div className="feature-accordion-display-section-list">
                                    {section?.items?.bulletList.map((item) => (
                                        <div key={item} className="feature-accordion-display-section-list-item">
                                            <CheckmarkIcon className="feature-accordion-display-section-list-icon" />
                                            <span className="feature-accordion-display-section-list-text">{item}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export { FeatureAccordionComponentDisplay }; 